import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { styled } from "styled-components";
import { useDispatch, useSelector } from "react-redux";

import UserSidebar from "../Sidebars/userSidebar";
import UserNav from "../UsersPage/UserNav";
import { closeSideBarState, openSideBarState } from "../redux/slices/appSlice";

export default function UserDashboardLayout() {
  const { openSideBar } = useSelector((state) => state.app);
  const dispatch = useDispatch();

  const isSidebarOpen = Boolean(openSideBar);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const query = window.matchMedia("(max-width: 1120px)");

    const updateSidebarState = (matches) => {
      if (matches) {
        dispatch(closeSideBarState());
      } else {
        dispatch(openSideBarState());
      }
    };

    updateSidebarState(query.matches);

    const handler = (event) => updateSidebarState(event.matches);

    if (typeof query.addEventListener === "function") {
      query.addEventListener("change", handler);
      return () => query.removeEventListener("change", handler);
    }

    query.addListener(handler);
    return () => query.removeListener(handler);
  }, [dispatch]);

  const handleBackdropClick = () => {
    dispatch(closeSideBarState());
  };

  return (
    <Wrapper >
      <div className="layout">
        {/* Sidebar full height on the left */}
        <aside
          className={`sidebar ${isSidebarOpen ? "closed" : "open"}`}
        >
          <UserSidebar />
        </aside>

        <div
          className={`mobile-backdrop ${isSidebarOpen ? "visible" : ""}`.trim()}
          onClick={handleBackdropClick}
          role="presentation"
        />

        {/* Main content */}
        <main className="content">
          {/* Fixed Navbar */}
          <div className="navbar">
            <UserNav />
          </div>

          {/* Scrollable Outlet below */}
          <div className="outlet">
            <Outlet />
          </div>
        </main>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  --sidebar-width: 250px;
  --navbar-height: 88px;

  min-height: 100vh;
  display: flex;
  width: 100%;

  .layout {
    display: flex;
    flex: 1;
    min-height: 100vh;
    position: relative;
  }

  /* Sidebar default (desktop mode) */
  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: var(--sidebar-width);
    flex-shrink: 0;
    background: #060b130a;
    border-right: 1px solid #ddd;
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    z-index: 9999;
  }

  .sidebar.closed {
    transform: translateX(0);
  }

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
   
    position: relative;
    margin-left: var(--sidebar-width);
    padding: 0;
    padding-top: var(--navbar-height);
  }

  .navbar {
    position: fixed;
    top: 0;
    left: var(--sidebar-width);
    right: 0;
    display: flex;
    align-items: center;
    background: #060b130a;
    border-bottom: 1px solid rgba(15, 23, 42, 0.08);
    z-index: 1000;
  }

  .navbar > * {
    width: 100%;
    box-sizing: border-box;
  }

  .outlet {
    flex: 1;
    overflow: auto;
     background: #060b130a;
    height: calc(100vh - var(--navbar-height));
    /* padding: 24px 32px; */
    box-sizing: border-box;
  }

  .mobile-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    
    pointer-events: none; 
    
  }

  .mobile-backdrop.visible {
    opacity: 1;
    pointer-events: auto;
  }

  /* Tablet / Mobile (slide animation instead of collapse) */
  @media screen and (max-width: 1120px) {
    .sidebar {
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      z-index: 1000;
      transform: translateX(-100%);
      box-shadow: 0 0 20px rgba(15, 23, 42, 0.3);
    }

    &[data-sidebar-open="true"] .sidebar {
      transform: translateX(0);
    }


    

    .content {
      margin-left: 0 !important; /* content full width always */
      min-height: 100vh;
      transition: none;
      padding-top: var(--navbar-height);
    }

    .mobile-backdrop {
      display: block;
    }

    .navbar {
      left: 0;
      background: #ffffff;
    }

    .outlet {
      height: calc(100vh - var(--navbar-height));
      padding: 20px;
    }
  }

  @media screen and (min-width: 1121px) {
    .mobile-backdrop {
      display: none;
    }
  }
`;
